module.exports = __webpack_public_path__ + "d17a1f356bbb44f142f2df9d38dc8721.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_clemens_mobile.jpg
// module id = 665
// module chunks = 0